import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, MailCheckIcon, PrinterIcon } from 'lucide-react';
const steps = [{
  Icon: CreditCardIcon,
  number: '01',
  title: 'Dokonaj bezpiecznej płatności',
  description: 'Jednorazowa płatność za cały pakiet.'
}, {
  Icon: MailCheckIcon,
  number: '02',
  title: 'Odbierz dostęp cyfrowy',
  description: 'Po zakupie otrzymasz materiały w formie cyfrowej.'
}, {
  Icon: PrinterIcon,
  number: '03',
  title: 'Pobierz, wydrukuj i ucz',
  description: 'Wybierz materiały potrzebne na najbliższą lekcję i wykorzystaj je w swojej klasie.'
}];
export function HowItWorks() {
  return <section className="w-full bg-chem-soft/80 px-5 py-14 sm:py-20" data-id="element-206" data-mp="crghepaqaynb">
      <div className="mx-auto max-w-5xl" data-id="element-207" data-mp="gsrww1zw23hs">
        <h2 className="text-center font-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-208" data-mp="grqjhqveh4ww">
          Jak to działa
        </h2>

        <ol className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-209" data-mp="19ae2n0qu69vc">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-210" data-mp="2rleg2clg7m39" data-mpi={i}>
              <motion.li initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.3,
            delay: i * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-211" data-mp="2rm7k35t0vxhp">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-chem/25 bg-white text-chem" data-id="element-212" data-mp="3ae8ososhahz1">
                  <step.Icon className="h-7 w-7" aria-hidden="true" data-id="element-213" data-mp="3ka3a5ro36r5i" />
                </span>
                <span className="mt-4 font-display text-2xl font-bold text-chem" data-id="element-214" data-mp="3fb8rqqu174lx">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-ink" data-id="element-215" data-mp="1pxdfh7pw9dx2">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink/70" data-id="element-216" data-mp="1kxr6xbl0glul">
                  {step.description}
                </p>
              </motion.li>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-chem/30 md:hidden" aria-hidden="true" data-id="element-217" data-mp="3pyadne9bjx19" />}
            </React.Fragment>)}
        </ol>
      </div>
    </section>;
}